/**
 * Card Component
 * Reusable card container matching SpellTales design system
 */

import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  subtitle?: string;
  actions?: ReactNode;
  variant?: 'default' | 'elevated' | 'bordered';
}

export const Card = ({
  className = '',
  title,
  subtitle,
  actions,
  variant = 'default',
  children,
  ...props
}: CardProps) => {
  const variants = {
    default: 'border border-slate-200 bg-white shadow-sm',
    elevated: 'bg-white shadow-md',
    bordered: 'border-2 border-slate-200 bg-white',
  };

  return (
    <div
      className={`rounded-3xl ${variants[variant]} ${className}`}
      {...props}
    >
      {(title || subtitle || actions) && (
        <div className="flex items-start justify-between border-b border-slate-200 p-6">
          <div>
            {title && (
              <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
            )}
            {subtitle && (
              <p className="mt-1 text-sm text-slate-600">{subtitle}</p>
            )}
          </div>
          {actions && <div className="ml-4">{actions}</div>}
        </div>
      )}
      <div className="p-6">{children}</div>
    </div>
  );
};
